import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface EvaluationData {
  captionName: string;
  controlName: string;
  controlName2: string;
  controlType: string;
  placeholder?: string;
  selectedValue?: string;
  selectedValue2?: string;
  selectedValue3: [];
  options?: Array<{
    optionName: string;
    value: string;
  }>;
  validators?: {
    required?: boolean;
    minlength?: number;
    maxlength?: number;
  };
  Options?: Array<{
    optionName: string;
    value: string;
  }>;
  required?: boolean;
  minlength?: number;
  maxlength?: number;
}

@Component({
    selector: 'app-evaluation-form',
    templateUrl: './evaluation-form.component.html',
    styleUrls: ['./evaluation-form.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class EvaluationFormComponent implements OnInit {
  @Input() formData: EvaluationData[];
  form: FormGroup;
  submitted: boolean;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  pageurl: string;
  url: string;
  ReportID: any;
  buttonName: string;
  ID: any;
  editable: boolean;
  SelectedValue: any;
  SelectedValue2: any;
  SelectedValue3: [];
  ParameterFor: string;
  ContextID: string;
  RightsID: string;
  IsDisplayButton: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService ) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202054001') ) {
      this.IsDisplayButton="1";
    } else {
      this.IsDisplayButton="0";
    }
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ParameterFor = pagehead[3];
    this.ContextID = pagehead[2];
    const formGroup = {};
    this.form = new FormGroup(formGroup);
    this.buttonName = "Submit";
   // this.form = this.formBuilder.group({ ID:['']});
    this.http.get(this.url + 'EvalForm/GetEvaluationDesign?ParameterFor='+this.ParameterFor+'&ContextID=' + this.ContextID)
    .subscribe( (res) => { this.formData = JSON.parse(res.toString());
      console.log(this.formData);
                           this.formData.forEach(formControl => {
                              formGroup[formControl.controlName] = new FormControl("");
                              if (formControl.controlName2 != "" && formControl.controlName2 != null) {
                              formGroup[formControl.controlName2] = new FormControl(""); }
                              this.form = new FormGroup(formGroup);
                            });
                           for (var val of JSON.parse(res.toString())) {
                             this.SelectedValue = val.selectedValue;
                             this.SelectedValue2 = val.selectedValue2;
                             this.SelectedValue3 = val.selectedValue3;
                             if (val.controlType == "DTP2") { if (this.SelectedValue == "") {
                              let date: Date = new Date();
                              this.SelectedValue = date;
                              this.SelectedValue2 = date; }
                             }
                             (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue);
                             if (val.controlName2 != "" && val.controlName2 != null) {
                              (this.form.get(val.controlName2) as FormControl).patchValue(this.SelectedValue3); }
                             if (val.controlType == "HLP") {
                               (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue2);
                               }
                            }
                          } );
  }
  Approve(){
    console.log(this.form.value);
    this.http.post(this.url + 'EvalForm/InsertUpdateApprovedEvaluationData', this.form.value).subscribe( (data) =>   {
      if (data == null) {
        this.alertService.error('Check Your InterNet Connection, Try Again Later',true);
      }
      else{
        this.alertService.success(data.toString(),this.options);
      }
     }
  );
  }
  Reject(){
    console.log(this.form.value);
    this.http.post(this.url + 'EvalForm/InsertUpdateRejectEvaluationData', this.form.value).subscribe( (data) =>   {
      if (data == null) {
        this.alertService.error('Check Your InterNet Connection, Try Again Later',true);
      }
      else{
        this.alertService.success(data.toString(),this.options);
      }
     }
  );
  }
  submitForm() {
   
    this.submitted = true;
    console.log(this.form.value);
    this.http.post(this.url + 'EvalForm/InsertUpdateEvaluationData', this.form.value).subscribe( (data) =>   {
          if (data == null) {
            this.alertService.error('Check Your InterNet Connection, Try Again Later',true);
          }
          else{
            this.alertService.success(data.toString(),this.options);
          }
         }
      );
    }

}
